import axios from "axios";
import BaseTra from "../baseTra";
import { logAzureTra } from "../../speech-service-log/log";

export default class AzureTra extends BaseTra {
  _sourceLang;
  _targetLangs;
  _authorizationToken;
  _url = "https://api.cognitive.microsofttranslator.com/translate";

  constructor(authorizationToken, sourceLang, targetLangs) {
    super();
    this._authorizationToken = authorizationToken;
    this._targetLangs = targetLangs;
    this._sourceLang = sourceLang;
  }

  async translate(text) {
    try {
      const res = await axios.post(
        this._url,
        [
          {
            text,
          },
        ],
        {
          headers: {
            Authorization: "Bearer " + this._authorizationToken,
            "Content-type": "application/json",
          },
          params: {
            "api-version": "3.0",
            from: this._sourceLang,
            to: this._targetLangs,
          },
        }
      );

      const resData = res.data;

      logAzureTra(resData);

      return resData[0]?.translations[0]?.text;
    } catch (err) {
      console.error(err);
    }
  }

  static fromToken(token, sourceLang, targetLang){
    return new AzureTra(token, sourceLang, targetLang);
  }
}
